// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".1b4be7fdc8e025e5fa213dc11d2787a2.js";
};